import { defineAsyncComponent } from 'vue'
export default {
  "auth-form-layout": defineAsyncComponent(() => import("/workspace/frontend/layouts/AuthFormLayout.vue").then(m => m.default || m)),
  "in-product-layout": defineAsyncComponent(() => import("/workspace/frontend/layouts/InProductLayout.vue").then(m => m.default || m))
}